<div id="substitute-product">
  <div>
    <div class="title-nav">
      <ion-icon
        name="chevron-back-outline"
        (click)="goBack()"
        data-cy="flipside-product-title"
      ></ion-icon
      >{{
        exceptionType === exceptionTypes.PRODUCT_UNAVAILABLE
          ? ('i18n.orderExceptionsPage.replacement' | translate)
          : ('i18n.orderExceptionsPage.substitute' | translate)
      }}
    </div>
    <div class="substitute-product-row">
      <div class="exception-img">
        <img
          src="{{ thumbnailImageURL }}"
          (error)="
            this.thumbnailImageURL = getAternativeThumbnail(thumbnailImageURL)
          "
          *ngIf="!!thumbnailImageURL && !isOffline"
          [attr.data-cy]="
            'flipside-product-' + product?.productNumber + '-image'
          "
          class="product-image"
        />
        <ion-icon
          name="restaurant"
          *ngIf="!thumbnailImageURL || isOffline"
          data-cy="flipside-product-no-image-icon"
          class="product-image no-image"
        ></ion-icon>
      </div>
      <div class="product-information">
        <div
          class="brand"
          [attr.data-cy]="
            'flipside-product-' + product?.productNumber + '-brand-text'
          "
        >
          {{ product?.summary?.brand | acronymTitleCase }}
        </div>
        <div
          class="description"
          [attr.data-cy]="
            'flipside-product-' + product?.productNumber + '-description-text'
          "
        >
          {{ product?.summary?.productDescTxtl | acronymTitleCase }}
        </div>
      </div>
    </div>

    <div class="additional-product-info">
      <span
        [attr.data-cy]="
          'flipside-product-' + product?.productNumber + '-number-text'
        "
        >#{{ product?.productNumber }}</span
      >
      <span class="border">|</span>
      <span
        [attr.data-cy]="
          'flipside-product-' + product?.productNumber + '-pack-size-text'
        "
      >
        {{ product?.summary?.salesPackSize }}</span
      >
    </div>

    <div
      class="note"
      *ngIf="isPackSizeDifferent"
      data-cy="flipside-product-packsize-different-text"
    >
      {{ 'i18n.orderExceptionsPage.packSizeDifferent' | translate }}
    </div>

    <div class="quantity-input-group">
      <div class="quantity-input">
        <app-quantity-input
          #unitsOrderedInput
          [productNumber]="product?.summary?.productNumber"
          [quantity]="
            exceptionResolution?.resolutionOrderItem?.substituteProduct
              ?.unitsOrdered &&
            exceptionResolution?.resolutionOrderItem?.substituteProduct
              .productNumber === product?.summary?.productNumber
              ? exceptionResolution?.resolutionOrderItem?.substituteProduct
                  ?.unitsOrdered
              : subOrReplaceItem
                ? subOrReplaceItem?.unitsOrdered
                : exceptionResolution?.orderItem?.unitsOrdered
          "
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
          [isEaches]="false"
          [isDisabled]="false"
          [platform]="platformEnum"
          [isProductCard]="true"
        >
        </app-quantity-input>
        <!-- <input type="text" [value]="subOrderItem?.unitsOrdered?.currentValue" /> -->
        <div
          class="price"
          [attr.data-cy]="
            'flipside-product-' + product?.productNumber + '-unit-price-text'
          "
        >
          {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
          {{ product?.summary?.priceUom || 'CS' }}
        </div>
      </div>
      <div class="quantity-input" *ngIf="product?.summary.breakable">
        <app-quantity-input
          #eachesOrderedInput
          [productNumber]="product?.summary?.productNumber"
          [quantity]="
            exceptionResolution?.resolutionOrderItem?.substituteProduct
              ?.eachesOrdered &&
            exceptionResolution?.resolutionOrderItem?.substituteProduct
              .productNumber === product?.summary?.productNumber
              ? exceptionResolution?.resolutionOrderItem?.substituteProduct
                  ?.eachesOrdered
              : exceptionResolution?.orderItem?.eachesOrdered
          "
          (quantityUpdateEmitter)="changeQuantityHandler($event)"
          [isEaches]="true"
          [isDisabled]="false"
          [platform]="platformEnum"
          [isProductCard]="true"
        >
        </app-quantity-input>
        <!-- <input type="text" [value]="subOrderItem?.eachesOrdered?.currentValue" /> -->
        <div
          class="price"
          [attr.data-cy]="
            'flipside-product-' + product?.productNumber + '-each-price-text'
          "
        >
          {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
          {{ product?.summary?.priceUom === 'LB' ? 'LB' : 'EA' }}
        </div>
      </div>
    </div>
  </div>

  <div class="substitute-action-btn">
    <ion-button
      [ngClass]="
        ('Substituted' === exceptionResolution?.resolutionType ||
          'Replaced' === exceptionResolution?.resolutionType) &&
        exceptionResolution?.resolutionOrderItem?.substituteProduct
          .productNumber === product?.summary?.productNumber &&
        !quantityChanged
          ? 'usf-fill-disabled-button'
          : 'usf-fill-green-button'
      "
      (click)="
        ('Substituted' === exceptionResolution?.resolutionType ||
          'Replaced' === exceptionResolution?.resolutionType) &&
        exceptionResolution?.resolutionOrderItem?.substituteProduct
          .productNumber === product?.summary?.productNumber &&
        !quantityChanged
          ? null
          : onExceptionResolution()
      "
      data-cy="confirm-quantity-flipside-button"
    >
      {{ 'i18n.common.confirm' | translate }}
    </ion-button>
  </div>
</div>
